export const TABLE_HEADERS = {
	avatar: 'Avatar',
	fullName: 'Full name',
	email: 'Email',
	phoneNumber: 'Phone number',
	age: 'Age',
	gender: 'Gender',
	location: 'Location',
	forms: 'Forms',
	totalTimeSpent: 'Total',
	completedHours: 'Completed hours',
	select: 'Select',
	chesedName: 'Chesed name',
	date: 'Date',
	start: 'Start at',
	end: 'End at',
	duration: 'Duration',
	coordinator: 'Coordinator',
	challenge: 'Challenge name',
	volunteers: 'Possible Volunteers',
	volunteer: 'Volunteer',
	logo: 'Logo',
	orgName: 'Organization name',
	owner: 'Owner',
	typeOrg: 'Type',
	contacts: 'Contacts',
	listOrganizations: 'List Organizations',
	totalVolunteers: 'Volunteers',
	totalUsers: 'Users',
	totalOppo: 'Opportunities',
	totalOppoHours: 'Opportunity hours',
	role: 'Role',
	position: 'Position',
	organization: 'Organization',
	admin: 'Admin',
	marketer: 'Marketer',
	member: 'Member',
	volunteerRole: 'Volunteer',
	organizations: 'Organizations',
	coins: 'Coins',
	grade: 'School grade',
	spendTime: 'Spend time',
	// suspend: 'Active status',
};
